module.exports = __webpack_public_path__ + "img/huandeng02.492501b7.png";